<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      :fixed-header="true"
      item-key="idaplicativo"
      class="elevation-2 table-acl-resposivo"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Permissões</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-text-field
            class="mr-4"
            v-model="search"
            outlined
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            @click="
              dialog = true;
              defaultSwitch();
              editando = false;
              moduloApp = [];
            "
            >Novo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Permissões" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon title="Remover Permissões" @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <div id="titulo-dialog">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title id="text-title">Controle de Acesso</v-toolbar-title>
        </div>
        <!-- <v-toolbar flat dark color="#042333">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Controle de Acesso</v-toolbar-title>
        </v-toolbar> -->
        <v-card-text class="pt-5">
          <v-layout>
            <v-flex xs7>
              <h2 id="descricao-lista">
                <v-icon>mdi-format-list-text</v-icon> LISTA DE APLICATIVOS POR
                PERFIL
              </h2>
            </v-flex>
            <v-flex xs1>
              <v-icon id="help" @click="dialogHelp = true"
                >mdi-help-circle</v-icon
              >
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                v-model="idperfil"
                :items="selects.perfil.items"
                label="Selecione um Perfil"
                item-text="descricao_perfil"
                item-value="idperfil"
                clearable
                outlined
                @change="
                  buscarPermissoesPerfil();
                  editando = false;
                "
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-expansion-panels
            v-model="moduloApp"
            multiple
            accordion
            class="mb-0"
          >
            <v-expansion-panel v-for="(item, i) in items" :key="i" id="painel">
              <v-expansion-panel-header color="#F0F0F0">
                <div class="titulo-painel">
                  <v-icon>{{ item.icon }}</v-icon>
                  <span>{{ item.title }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content :key="i">
                <div
                  v-for="(subItem, subI) in item.items"
                  :key="subI"
                  class="aplicativos"
                >
                  <span>{{ subItem.title }}</span>
                  <v-spacer></v-spacer>
                  <v-switch
                    class="mr-5 mt-5 btn-switch"
                    v-model="subItem.switch_app"
                    :label="subItem.switch_app ? ' Ativado' : ' Desativado'"
                    :disabled="idperfil > 0 ? false : true"
                    @change="save(subItem)"
                  ></v-switch>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHelp" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Informação
        </v-card-title>
        <v-card-text class="mt-5">
          <p>
            Esta Tela é destinada ao <b>CONTROLE DE ACESSO.</b> Nela são  definidos os
			<b>APLICATIVOS</b> de cada <b>Perfil.</b>
          </p>
          <p>
            Aplicativos marcados como ativado estarão acessíveis aos usuários
            pertencentes ao perfil correspondente.
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogHelp = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import UsuarioAPI from "./../../api/usuario";
import AclAPI from "./../../api/acl";

export default {
  props: ["filtrar_admin"],

  data: () => ({
    dialogHelp: false,
    dialog: false,
    editando: false,

    idperfil: "",
    search: "",
    headers: [
      { text: "ID Perfil", value: "idperfil", align: "center" },
      { text: "Perfil", align: "left", value: "descricao_perfil" },
      { text: "ID Aplicativo", value: "idaplicativo", align: "center" },
      { text: "Aplicativo", align: "left", value: "descricao_aplicativo" },
      { text: "View", value: "view", align: "center" },
      { text: "Add", value: "add", align: "center" },
      { text: "Edit", value: "edit", align: "center" },
      { text: "Del", value: "del", align: "center" },
      {
        text: "",
        value: "action",
        sortable: false,
        width: "100px",
        align: "center",
      },
    ],
    desserts: [],
    items: [],
    moduloApp: [],
    selects: {
      perfil: {
        items: [],
      },
    },
  }),
  watch: {
    idperfil() {
      if (!this.idperfil > 0 || this.idperfil == "") {
        this.moduloApp = [];
      }
    },
  },
  created() {
    this.initialize();
    this.getAcessos();
  },
  methods: {
    editItem(i) {
      this.moduloApp = [];

      this.items.forEach((item, index) => {
        item.items.forEach((subItem) => {
          if (i.idaplicativo == subItem.idaplicativo) {
            this.moduloApp.push(index);
          }
        });
      });
      this.dialog = true;
      this.editando = true;
      this.idperfil = i.idperfil;
      this.buscarPermissoesPerfil();
    },

    save(app) {
      if (app.idaplicativo > 0 && this.idperfil > 0) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          idperfil: this.idperfil,
          idaplicativo: app.idaplicativo,
        };

        AclAPI.setAplicativoPerfil(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.buscarPermissoesPerfil();
          })
          .catch(() => {
            this.Helpers.logout();
          });
      }
    },

    buscarPermissoesPerfil() {
      if (this.idperfil > 0) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = { idperfil: this.idperfil };

        AclAPI.getPermissoesPerfil(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (!this.editando) this.moduloApp = [];

            this.items.forEach((item, i) => {
              if (!this.editando) this.moduloApp.push(i);

              item.items.forEach((subItem, subI) => {
                this.items[i].items[subI].switch_app = false;

                response.data.permissoes.forEach((permis) => {
                  if (permis.idaplicativo === subItem.idaplicativo) {
                    this.items[i].items[subI].switch_app = true;
                  }
                });
              });
            });
          })
          .catch(() => {
            this.Helpers.logout();
          });
      } else {
        this.defaultSwitch();
      }
    },

    defaultSwitch() {
      this.items.forEach((item, i) => {
        item.items.forEach((subItem, subI) => {
          this.items[i].items[subI].switch_app = false;
        });
      });
    },

    getAcessos() {
      const headers = this.Helpers.iniciarRequisicao();

      AclAPI.getAplicativosModulos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.items = [];
            this.moduloApp = [];

            response.data.app.forEach((item, i) => {
              this.moduloApp.push(i);
              this.items.push(item);
            });
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        filtrar_admin: this.filtrar_admin ? "S" : "N",
      };

      UsuarioAPI.getPerfis(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.perfil.items = response.data.perfis;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      AclAPI.getPermissoes(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.grants;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch("loading/habilitarLoading", false);
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover permissão?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delPermissao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};

                this.initialize();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.initialize();
      this.dialog = false;
      this.idperfil = "";
      this.defaultSwitch();
    },
  },
};
</script>
<style scoped>
.ml-80 {
  margin-left: 80px;
}

#descricao-lista {
  margin-top: 10px;
  color: #444;
}

.titulo-painel {
  font-size: 13pt;
}
.titulo-painel span {
  margin-left: 15px;
}

.aplicativos {
  margin-left: -25px;
  margin-right: -25px;
  height: 65px;
  font-size: 12pt;
  padding-left: 90px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.aplicativos:hover {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background: #f5f5f5;
}

.aplicativos span {
  margin-top: 20px;
}

#help {
  color: #444;
  margin-top: 18px;
  margin-left: 60px;
  font-size: 13pt;
  cursor: pointer;
}

.v-expansion-panel-content .aplicativos:last-child {
  border-bottom: 0;
}
</style>
<style>
#painel .v-expansion-panel-content__wrap {
  padding: 0 24px 0px !important;
}

.btn-switch .v-input--selection-controls__input {
  right: 85px !important;
  position: absolute !important;
}
#titulo-dialog {
  display: flex;
  background: #042333;
  margin-bottom: 10px;
  color: #FFF;
  padding: 10px;
  padding-top: 14px;
  padding-bottom: 14px;
}

#titulo-dialog #text-title {
  margin-top: 3px;
  margin-left: 20px;
}
</style>
